import z from 'zod';

export const languageListSchema = z.object({
  name: z.string().optional(),
  title: z.record(z.string(), z.string()).optional(),
});

export type LanguageListResponse = z.infer<typeof languageListSchema>;

export const staticTextSearchRequestSchema = z.object({
  type: z.string().optional(),
  orderColumn: z.string().optional(),
  orderType: z.string().optional(),
  pageSize: z.number().optional(),
  pageNumber: z.number().optional(),
  key: z.string().optional(),
  value: z.string().optional(),
});

export const staticTextItemSchema = z.object({
  id: z.string().nullable(),
  key: z.string().nullable(),
  value: z.string().nullable(),
  type: z.enum(['Api', 'MobileClient', 'WebClient', 'Error', 'MobileStaticContent', 'WebStaticContent']).nullable(),
});

export const staticTextSearchResponseSchema = z.object({
  totalCount: z.number(),
  result: z.array(staticTextItemSchema),
});

export type StaticTextSearchRequest = z.infer<typeof staticTextSearchRequestSchema>;
export type StaticTextItem = z.infer<typeof staticTextItemSchema>;
export type StaticTextSearchResponse = z.infer<typeof staticTextSearchResponseSchema>;

export const textTypeDropdownItemSchema = z.object({
  value: z.number(),
  key: z.string(),
  description: z.string(),
});

export const textTypesDropdownResponseSchema = z.array(textTypeDropdownItemSchema);

export type TextTypeDropdownItem = z.infer<typeof textTypeDropdownItemSchema>;
export type TextTypesDropdownResponse = z.infer<typeof textTypesDropdownResponseSchema>;

export const createStaticTextRequestSchema = z.object({
  key: z.string(),
  value: z.record(z.string(), z.string()),
  type: z.enum(['Api', 'MobileClient', 'WebClient', 'Error', 'MobileStaticContent', 'WebStaticContent']),
});

export const createStaticTextResponseSchema = z.any();

export type CreateStaticTextRequest = z.infer<typeof createStaticTextRequestSchema>;
export type CreateStaticTextResponse = z.infer<typeof createStaticTextResponseSchema>;

export const updateStaticTextRequestSchema = z.object({
  value: z.record(z.string(), z.string()),
});

export const updateStaticTextResponseSchema = z.any();

export type UpdateStaticTextRequest = z.infer<typeof updateStaticTextRequestSchema>;
export type UpdateStaticTextResponse = z.infer<typeof updateStaticTextResponseSchema>;

export const staticTextDetailResponseSchema = z.object({
  id: z.string(),
  key: z.string(),
  value: z.record(z.string(), z.string()),
  type: z.enum(['Api', 'MobileClient', 'WebClient', 'Error', 'MobileStaticContent', 'WebStaticContent']),
});

export type StaticTextDetailResponse = z.infer<typeof staticTextDetailResponseSchema>;

export const deleteStaticTextResponseSchema = z.any();

export type DeleteStaticTextResponse = z.infer<typeof deleteStaticTextResponseSchema>;

export const organizationLanguageSchema = z.object({
  languageId: z.string(),
  languageName: z.string(),
  isDefault: z.boolean(),
  status: z.enum(['Passive', 'Active']),
});

export const organizationLanguagesResponseSchema = z.array(organizationLanguageSchema);

export type OrganizationLanguage = z.infer<typeof organizationLanguageSchema>;
export type OrganizationLanguagesResponse = z.infer<typeof organizationLanguagesResponseSchema>;
